import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const etrongt: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interior', 'steeringWheels'],
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/setrongt.html',
};

const setrongt: PartialCarConfiguration = {
	...etrongt,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/setrongt.html',
};

const rsetrongt: PartialCarConfiguration = {
	...etrongt,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/rsetrongt.html',
};

const rsetrongtperformance: PartialCarConfiguration = {
	...etrongt,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/rsetrongtperformance.html',
};

const etrongt_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const setrongt_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const rsetrongt_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};
const rsetrongtperformance_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export {
	etrongt,
	etrongt_ui,
	rsetrongt,
	rsetrongt_ui,
	rsetrongtperformance,
	rsetrongtperformance_ui,
	setrongt,
	setrongt_ui,
};
